import { render, staticRenderFns } from "./aiWatchingAudio.vue?vue&type=template&id=583a4cb0"
import script from "./aiWatchingAudio.vue?vue&type=script&lang=ts"
export * from "./aiWatchingAudio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports